import React, { useEffect, useState } from 'react'
import { Table, Input, Button, Modal, Form, Row, Col } from 'antd'
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  DollarOutlined,
  FileTextOutlined,
} from '@ant-design/icons'
import axiosInstance from '../../Utils/axiosInstance'
import {
  CreateFeeData,
  GetFeeData,
  UpdateFeeData,
  DeleteFeeData,
} from "../../API's/AdminApi"
import { toast } from 'react-toastify'

export default function FeeMaster() {
  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [showForm, setShowForm] = useState(false)
  const [editData, setEditData] = useState(null)
  const [deleteId, setDeleteId] = useState(null)

  const [tableLoading, setTableLoading] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
    const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
  })

  const [form] = Form.useForm()

  // ---------------- GET DATA ----------------
  const getFees = async () => {
    try {
      setTableLoading(true)
      const res = await axiosInstance.get(GetFeeData)
      setData(res.data || [])
    } catch (error) {
      toast.error('Failed to load fees')
    } finally {
      setTableLoading(false)
    }
  }

  useEffect(() => {
    getFees()
  }, [])

  // ---------------- ADD / UPDATE ----------------
  const onFinish = async (values) => {
    try {
      setSubmitLoading(true)
      let res

      if (editData) {
        res = await axiosInstance.put(UpdateFeeData, {
          id: editData.id,
          feeName: values.feeName,
        })

        if (res.data === 'UPDATED') {
          toast.success('Fee updated successfully')
        } else if (res.data === 'ALREADYEXISTS') {
          toast.warn('Fee already exists!')
        }
      } else {
        res = await axiosInstance.post(CreateFeeData, {
          feeName: values.feeName,
        })

        if (res.data === 'SAVED') {
          toast.success('Fee created successfully')
        } else if (res.data === 'ALREADYEXISTS') {
          toast.warn('Fee already exists!')
        }
      }

      form.resetFields()
      setShowForm(false)
      setEditData(null)
      getFees()
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Something went wrong')
    } finally {
      setSubmitLoading(false)
    }
  }

  // ---------------- EDIT ----------------
  const handleEdit = (record) => {
    setEditData(record)
    setShowForm(true)

    form.setFieldsValue({
      feeName: record.feeName,
    })
  }

  // ---------------- DELETE ----------------
  const confirmDelete = async () => {
    try {
      setDeleteLoading(true)

      const res = await axiosInstance.delete(`${DeleteFeeData}?id=${deleteId}`)

      if (res.data) {
        toast.success(res.data.message || 'Deleted successfully')
        setDeleteId(null)
        getFees()
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Delete failed')
    } finally {
      setDeleteLoading(false)
    }
  }

  // ---------------- TABLE ----------------
  const columns = [
    {
      title: 'Sr No',
      render: (_, __, index) => index + 1,
    },
    {
      title: 'Fee Name',
      dataIndex: 'feeName',
    },
    {
      title: 'Action',
      render: (_, record) => (
        <>
          <Button
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
            style={{ marginRight: 8 }}
          />

          {/* <Button
            danger
            icon={<DeleteOutlined />}
            onClick={() => setDeleteId(record.id)}
          /> */}
        </>
      ),
    },
  ]

  // ---------------- SEARCH ----------------
  const filteredData = data.filter((item) =>
    item.feeName?.toLowerCase().includes(searchText.toLowerCase()),
  )

  return (
    <div>
      {/* TABLE */}
      {!showForm && (
        <>
          <div className="page-background p-2 p-md-4">
            <div className="page-header">
              <h2>
                <FileTextOutlined style={{ marginRight: 8 }} />
                Fee Master
              </h2>
            </div>
            <Row gutter={16} className="pb-2 m-0">
              <Col xs={24} md={6} xl={15}></Col>
              <Col xs={24} md={12} xl={6} className="pt-2 pt-md-0">
                <Input
                  placeholder="Search here"
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </Col>

              <Col xs={24} md={6} xl={3} className="pt-2 pt-md-0 mt-1">
                <button
                  className="btn-aqua"
                  onClick={() => {
                    setShowForm(true)
                    setEditData(null)
                    form.resetFields()
                  }}
                >
                  <PlusOutlined /> Add Fee
                </button>
              </Col>
            </Row>

            <Table
              className="custom-table-header shadow"
              columns={columns}
              dataSource={filteredData}
              rowKey="id"
              bordered
              loading={tableLoading}
              style={{ overflowX: 'auto', backgroundColor: 'white' }}
              pagination={{
                showSizeChanger: true, // enable page size dropdown
                pageSizeOptions: ['5', '10', '20', '50'],
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total} items`,
              }}
            />
          </div>
        </>
      )}

      {/* FORM */}
      {showForm && (
        <div className="row p-0 m-0">
          <div className="col-12 col-md-2 col-lg-3 "></div>
          <div className="col-12 col-md-8 col-lg-6  page-background1 p-2 p-md-4">
            {/* HEADER */}
            <div className="page-header">
              <h2>
                <FileTextOutlined style={{ marginRight: 8 }} />
                Fee Master
              </h2>
            </div>
            <Form form={form} layout="vertical" onFinish={onFinish}>
              <Form.Item
                label="Fee Name"
                name="feeName"
                rules={[{ required: true, message: 'Enter fee name' }]}
              >
                <Input placeholder="Enter fee name" />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={submitLoading}
                >
                  {editData ? 'Update' : 'Submit'}
                </Button>

                <Button
                  style={{ marginLeft: 10 }}
                  onClick={() => {
                    setShowForm(false)
                    setEditData(null)
                    form.resetFields()
                  }}
                >
                  Cancel
                </Button>
              </Form.Item>
            </Form>
          </div>
          <div className="col-12 col-md-2 col-lg-3 "></div>
        </div>
      )}

      {/* DELETE MODAL */}
      <Modal
        title="Confirm Delete"
        open={deleteId !== null}
        onOk={confirmDelete}
        confirmLoading={deleteLoading}
        onCancel={() => setDeleteId(null)}
      >
        Are you sure you want to delete this fee?
      </Modal>
    </div>
  )
}
